// extracted by mini-css-extract-plugin
export default {"sidebar-col":"Layout_sidebar-col__wY7L0","collapsed":"Layout_collapsed__T3y+Z","layoutContainer":"Layout_layoutContainer__UwUP-","mainWrapper":"Layout_mainWrapper__nJtUN"};